export default __webpack_public_path__ + "static/media/logoutIcon.824ed10e.svg";